import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Navigator from '../Navigator'

class MenuItem extends Component {
  render () {
    const {
      history,
      data
    } = this.props

    const {
      titleOverride,
      item,
      featureImage
    } = data

    const title = titleOverride || item.title

    const splitted = title.split(' - ')

    return (
      <Navigator type={data.menuableType} id={data.menuableId} history={history}>
        <div className='jumplink' style={{ backgroundImage: `url('${featureImage}')` }}>
          <div className='jumplink-content'>
            {splitted.map((text, index) => {
              if (index === 0) {
                return <div key={text}>{text}</div>
              } else {
                return <span key={text}>{text}</span>
              }
            })}
          </div>
          <div className='overlay primary-1' />
        </div>
      </Navigator>
    )
  }
}

MenuItem.propTypes = {
  data: PropTypes.object,
  history: PropTypes.object
}

export default MenuItem



// WEBPACK FOOTER //
// ./src/components/menus/MenuItem.js